export const WELCOME_PAGE_All_KPIS = 'WelcomePageAllKpis';
export const GENERAL_INFO_MUNICIPALITIES_CHART = 'GeneralInfoMunicipalitiesChart';
export const SOURCE_STATIONS_KPIS = 'SourceStationsKpis';
export const SOURCE_STATIONS_CHART = 'SourceStationsChart';
export const LOCALIZATION_MAP_KEY = 'SourceStationsMap';
export const MV_NETWORKS_UNDERGROUNDING_KPIS = 'MvNetworksUndergroundingKpis';
export const MV_NETWORKS_UNDERGROUNDING_RATE_DEP_CHART = 'MvNetworkUndergroundRateDepChart';
export const MV_NETWORKS_UNDERGROUNDING_RATE_CONCESSION_CHART =
    'MvNetworkUndergroundRateConcessionChart';
export const MV_UNDERGROUNDING_RATE_MAP = 'MvUndergroundingRateMap';
export const MV_NETWORK_TYPE_EVOLUTION_CHART = 'MvNetworkTypeEvolutionChart';
export const MV_NETWORK_RENEWAL_RATE_CHART = 'MvNetworkRenewalRateChart';
export const MV_NETWORK_OMT_EVOLUTION_CHART = 'MvNetworkOmtEvolutionChart';
export const MV_NETWORKS_AGES_KPIS = 'MvNetworksAgesKPIs';
export const MV_NETWORKS_AVERAGE_AGES_CHART = 'MvNetworksAverageAgesChart';
export const MV_NETWORKS_AGES_COMPARISON_CHART = 'MvNetworksAgesComparisonChart';
export const MV_NETWORKS_LOW_SECTION_CHART = 'MvNetworksLowSectionChart';
export const MV_NETWORKS_PAPER_CHART = 'MvNetworksPaperChart';
export const MV_NETWORKS_OVER_40_CHART = 'MvNetworksOverFortyYearsOldChart';
export const MV_NETWORKS_VIGILANCE_POINTS_CHART = 'MvNetworksVigilancePointsChart';
export const MV_NETWORKS_CPI_LENGTH_MAP = 'MvNetworksCpiLengthMap';
export const LV_NETWORKS_UNDERGROUNDING_KPIS = 'LvNetworksUndergroundingKpis';
export const LV_NETWORKS_AGES_KPIS = 'LvNetworksAgesKPIs';
export const LV_NETWORKS_UNDERGROUNDING_TYPE_PROP_CHART = 'LvNetworksUndergroundingTypePropChart';
export const LV_NETWORKS_UNDERGROUNDING_RATE_DEP_CHART = 'LvNetworkUndergroundRateDepChart';
export const LV_NETWORKS_UNDERGROUNDING_RATE_CONCESSION_CHART =
    'LvNetworkUndergroundRateConcessionChart';
export const LV_NETWORKS_UNDERGROUNDING_RATE_MAP = 'LvUndergroundingRateMap';
export const LV_NETWORKS_AVERAGE_AGES_CHART = 'LvNetworksAverageAgesChart';
export const LV_NETWORKS_AGES_EVOL_LENGHT_CHART = 'LvNetworksAgesEvolOverheadChart';
export const LV_NETWORKS_AGES_EVOL_LENGHT_FS_CHART = 'LvNetworksAgesEvolOverheadFsChart';
export const LV_NETWORKS_AGES_RATE_COMPARISON_CHART = 'LvNetworksRateComparisonChart';
export const LV_AERIAL_BARE_NETWORK_RATE_MAP = 'LvAerialBareNetworkRateMap';
export const TRANSFORMER_SUBSTATIONS_KPIS = 'TransformerSubstationsKPIs';
export const METERS_KPIS = 'MetersKPIs';
export const METERS_TYPOLOGY_CHART = 'MetersTypologyChart';
export const LINKY_DEPLOYMENT_RATE_COMPARISON_CHART = 'LinkyDeploymentRateComparisonChart';
export const LINKY_METER_DEPLOYMENT_RATE_MAP = 'LinkyMeterDeploymentRateMap';
export const OTHERS_TRANSFORMER_EVOL_CHART = 'TransformerSubstationsEvolChart';
export const TRANSFORMER_GENERATION_CHART = 'TransformersGenerationChart';
export const TRANSFORMER_HIGH_CABINS_CHART = 'HighCabinsChart';
export const TRANSFORMER_MEAN_AGE_CHART = 'TransformersMeanAgeChart';
export const URBAN_RURAL_SUBSTATIONS_CHART = 'UrbanRuralSubstationsChart';
export const CONTINUITY_QUALITY_SUPPLY_B_CRITERION_KPI = 'ContinuityQualitySupplyBCriterionKPIs';
export const CONTINUITY_QUALITY_SUPPLY_B_CRITERION_BREAKDOWN_CHART =
    'ContinuityQualitySupplyCriterionBreakdownChart';
export const CONTINUITY_QUALITY_SUPPLY_B_CRITERION_ENEDIS_INVESTMENT_CHART =
    'ContinuityQualitySupplyCriterionEnedisInvestmentChart';
export const CONTINUITY_QUALITY_SUPPLY_MEAN_TCC_B_CRITERION_MAP =
    'ContinuityQualitySupplyMeanTccBCriterionMap';
export const CONTINUITY_QUALITY_SUPPLY_MEAN_HIX_B_CRITERION_MAP =
    'ContinuityQualitySupplyMeanHixBCriterionMap';
export const CONTINUITY_QUALITY_SUPPLY_TCC_B_CRITERION_MAP =
    'ContinuityQualitySupplyTccBCriterionMap';
export const CONTINUITY_QUALITY_SUPPLY_HIX_B_CRITERION_MAP =
    'ContinuityQualitySupplyHixBCriterionMap';
export const CONTINUITY_QUALITY_SUPPLY_QUALITY_DECREE_CHART =
    'ContinuityQualitySupplyQualityDecreeChart';
export const CONTINUITY_QUALITY_SUPPLY_OUTAGES_FREQUENCY_CHART =
    'ContinuityQualitySupplyOutagesFrequencyChart';
export const CONTINUITY_QUALITY_SUPPLY_OUTAGES_COMPARISON_CHART =
    'ContinuityQualitySupplyOutagesComparisonChart';
export const CONTINUITY_QUALITY_SUPPLY_MV_INCIDENT_CHART = 'ContinuityQualitySupplyMvIncidentChart';
export const CONTINUITY_QUALITY_SUPPLY_LV_INCIDENT_CHART = 'ContinuityQualitySupplyLvIncidentChart';
export const CONTINUITY_QUALITY_SUPPLY_INCIDENT_COMPARISON_CHART =
    'ContinuityQualitySupplyIncidentComparisonChart';
export const VOLTAGE_QUALITY_KPIS = 'VoltageQualityKPIs';
export const VOLTAGE_QUALITY_MV_DEPARTURES_TABLE = 'MvDeparturesTable';
export const VOLTAGE_QUALITY_SUBSTATION_CMA_TABLE = 'SubstationCmaTable';
export const VOLTAGE_QUALITY_COMPARISON_CHART = 'VoltageQualityComparisonChart';
export const EXPENSES_INVESTMENTS_CAPEX_KPIS = 'ExpensesInvestmentsCapexKPIs';
export const ACCOUNTING_INDICATORS_KPIS = 'AccountingIndicatorsKPIs';
export const OPERATING_ACCOUNT_KPIS = 'OperatingAccountKPIs';
export const OPERATING_PRODUCTS_EVOLUTION_CHART = 'OperatingProductsEvolutionChart';
export const OPERATING_COSTS_EVOLUTION_CHART = 'OperatingCostsEvolutionChart';
export const OPERATING_RESULT_EVOLUTION_CHART = 'OperatingResultEvolutionChart';
export const OPERATING_MARGIN_RATE_EVOLUTION_CHART = 'OperatingMarginRateEvolutionChart';
export const VOLTAGE_QUALITY_EVOL_MV_DEPART_CHART = 'VoltageQualityEvolMvDepartChart';
export const VOLTAGE_QUALITY_EVOL_LV_DEPART_CHART = 'VoltageQualityEvolLvDepartChart';
export const VOLTAGE_QUALITY_EVOL_RATE_CMA_CHART = 'VoltageQualityEvolRateCmaChart';
export const VOLTAGE_QUALITY_LV_CMA_RATE_MAP = 'LvCmaRateMap';
export const EXPENSES_INVESTMENTS_CAPEX_DEALER_AMOUNTS_CHART =
    'ExpensesInvestmentsCapexDealerChart';
export const EXPENSES_INVESTMENTS_CAPEX_LGHT_MV_TYPE_CHART =
    'ExpensesInvestmentsCapexLgtMvtypeChart';
export const EXPENSES_INVESTMENTS_CAPEX_LGHT_MV_WORK_CHART =
    'ExpensesInvestmentsCapexLgtMvWorkChart';
export const EXPENSES_INVESTMENTS_CAPEX_LGHT_LV_TYPE_CHART =
    'ExpensesInvestmentsCapexLgtLvtypeChart';
export const EXPENSES_INVESTMENTS_CAPEX_LGHT_LV_WORK_CHART =
    'ExpensesInvestmentsCapexLgtLvWorkChart';
export const EXPENSES_INVESTMENTS_CAPEX_AMOUNTS_NETWORK_PERF_CHART =
    'ExpensesInvestmentsCapexAmountsNetPerfChart';
export const ENEDIS_CUSTOMERS_KPIS = 'EnedisCustomersKpis';
export const ENEDIS_CUSTOMERS_TRANSPORT_REVENUES_CHART = 'EnedisCustomerTransportRevenuesChart';
export const ENEDIS_CUSTOMERS_MEAN_CONSUMPTION_CHART = 'EnedisCustomersMeanConsumptionChart';
export const ENEDIS_CUSTOMERS_MEAN_KWH_PRICE_CHART = 'EnedisCustomersMeanKwhPriceChart';
export const ENEDIS_CUSTOMERS_ENERGY_USERS_MAP = 'EnergyUsersMap';
export const ENEDIS_PRODUCERS_KPIS = 'EnedisEnergyProducersKPIs';
export const PRODUCTION_FACILITIES_DISTRIBUTION_CHART = 'ProductionFacilitiesDistributionChart';
export const PRODUCTION_FACILITIES_EVOLUTION_CHART = 'ProductionFacilitiesEvolutionChart';
export const PRODUCTION_FACILITIES_POWER_EVOLUTION_CHART =
    'ProductionFacilitiesPowerEvolutionChart';
export const ENEDIS_CONNECTIONS_KPIS = 'EnedisEnergyConnectionsKPIs';
export const ENEDIS_CONNECTIONS_COUNT_CHART = 'EnedisConnectionsCountChart';
export const ENEDIS_CONNECTIONS_PRODUCERS_COUNT_CHART = 'EnedisConnectionsProducersCountChart';
export const ENEDIS_CONNECTIONS_ESTIMATION_NOTICE_CHART = 'EnedisConnectionsEstimationNoticeChart';
export const ENEDIS_CONNECTIONS_COMMISSIONING_RATE_CHART =
    'EnedisConnectionsCommissioningRateChart';
export const ENEDIS_QUALITY_KPIS = 'EnedisQualityKPIs';
export const ENEDIS_CUSTOMERS_CLAIM_KPIS = 'EnedisCustomersClaimsKPIs';
export const ENEDIS_CUSTOMERS_CLAIMS_COMPARISON_CHART = 'EnedisClaimsRateComparisonChart';
export const ENEDIS_CUSTOMERS_CLAIM_RATE_MAP = 'EnedisClaimRateMap';
export const ENEDIS_CUSTOMERS_EVOL_NBR_LV_MV_CHART = 'EnedisCustomerNbrUsersLvMvChart';
export const ENEDIS_CUSTOMERS_EVOL_CONSUM_TOT_USERS_CHART = 'EnedisCustomerConsumTotUsersChart';
export const EDF_CUSTOMERS_TRV_KPIS = 'EdfTrvKPIs';
export const EDF_CUSTOMERS_TRV_COUNT_CHART = 'EdfTrvUsersCountChart';
export const EDF_CUSTOMERS_TRV_CONSUMPTIONS_CHART = 'EdfTrvConsumptionsChart';
export const EDF_CUSTOMERS_TRV_MEAN_CONSUMPTIONS_CHART = 'EdfTrvMeanConsumptionsChart';
export const EDF_CUSTOMERS_TRV_INCOME_CHART = 'EdfTrvIncomeChart';
export const EDF_CUSTOMERS_TRV_TARIFF_CHART = 'EdfTrvTariffChart';
export const EDF_CUSTOMERS_QUALITY_KPIS = 'EdfQualityKPIs';
export const EDF_CUSTOMERS_QUALITY_PHONE_CALL_SUCCESS_RATE_CHART = 'PhoneCallSuccessRateChart';
export const EDF_CUSTOMERS_QUALITY_CTS_CLIENT_RATE_CHART = 'EdfCtsClientRateChart';
export const EDF_CUSTOMERS_QUALITY_SELF_REPORT_BILLS_RATE_CHART = 'EdfSelfReportBillsRateChart';
export const EDF_CUSTOMERS_QUALITY_BLUE_CONTRACT_RATE_CHART = 'EdfBlueContractRateChart';
export const EDF_CUSTOMERS_QUALITY_BLUE_CONTRACT_RATE_COMPARISON_CHART =
    'EdfBlueContractRateComparisonChart';
export const EDF_CUSTOMERS_CLAIM_KPIS = 'EdfClaimKPIs';
export const EDF_CUSTOMERS_CLAIM_RATE_MAP = 'EdfClaimRateMap';
export const EDF_CUSTOMERS_CLAIM_RATE_COMPARISON_CHART = 'EdfClaimRateComparisonChart';
export const EDF_CUSTOMERS_POVERTY_KPIS = 'EdfPovertyKPIs';
export const EXPENSES_INVESTMENTS_CAPEX_AMOUNTS_CONNECTION_CHART =
    'ExpensesInvestmentsCapexAmountsConnectionChart';
export const EXPENSES_MAINTENANCE_OPEX_EVOL_EXPENDITURE_CHART =
    'ExpensesMaintenanceOpexEvolExpendChart';
export const ACCOUNTING_INDICATORS_EVOL_FIXED_ASSETS_CHART = 'AccountingEvolFixedAssetsChart';
export const ACCOUNTING_INDICATORS_GROSS_VALUE_COMPARISON_CHART =
    'AccountingValueRatioComparisonChart';
export const ACCOUNTING_INDICATORS_GROSS_VALUE_BREAKDOWN_CHART =
    'AccountingGrossValueBreakdownChart';
export const ACCOUNTING_INDICATORS_DEPRECIATION_RATE_COMPARISON_CHART =
    'AccountingRateDepreciationComparisonChart';
export const ACCOUNTING_INDICATORS_EVOL_GROSS_VALUE_CHART = 'AccountingEvolGrossValueUserChart';
export const ACCOUNTING_INDICATORS_EVOL_RATE_DEPREC_WORKS_CHART =
    'AccountingEvolRateDeprecWorksChart';
export const ACCOUNTING_INDICATORS_RATE_DEPREC_WORKS_FAMILY_CHART =
    'AccountingDepercRateWorksChart';
export const ACCOUNTING_RIGHTS_EVOL_ORIGIN_NETBOOK_CHART = 'AccountingRightsEvolOrgNetBookChart';
export const ACCOUNTING_RIGHTS_DISTRIB_ORIGIN_FINAN_CHART =
    'AccountingRightsDistribOriginFinanChart';
export const ACCOUNTING_REPLACEMENT_VALUE_CHART = 'AccountingReplacementValueChart';
export const ACCOUNTING_RIGHTS_GRANTOR_EVOL_CHART = 'AccountingRightsEvolGrantorChart';
export const ACCOUNTING_RIGHTS_BREAKDOWN_GRANTOR_CHART = 'AccountingRightsBreakdownGrantorChart';
export const ACCOUNTING_RIGHTS_EVOL_DEBTS_CHART = 'AccountingRightsEvolDebtsChart';
export const ACCOUNTING_TOTAL_PROVISION_CHART = 'AccountingTotalProvisionChart';
export const ACCOUNTING_PROVISIONS_DISTRIBUTION_CHART = 'AccountingProvisionsDistributionChart';
export const ENEDIS_CUSTOMERS_CLAIM_EVOL_COMLPLAINTS_CHART = 'EnedisClaimsEvolComplaintsChart';
export const ENEDIS_CUSTOMERS_CLAIM_EVOL_RATE_RESPONSE_CHART = 'EnedisClaimsEvolRateResponseChart';
export const ENEDIS_CUSTOMERS_CLAIM_EVOL_RATE_USERS_CHART = 'EnedisClaimsEvolRateComplUserChart';
export const EDF_CUSTOMERS_CLAIM_EVOL_COMLPLAINTS_CHART = 'EdfClaimsEvolComplaintsChart';
export const EDF_CUSTOMERS_CLAIM_DISTRIB_COMPLAINTS_CHART = 'EdfClaimsDistribComplaintsChart';
export const EDF_CUSTOMERS_CLAIM_RATE_RESPONSE_CHART = 'EdfClaimsEvolRateResponseChart';
export const EDF_CUSTOMERS_POVERTY_EVOL_BENEFICIARIES_CHART = 'EdfPovertyEvolBeneficiariesChart';
export const EDF_CUSTOMERS_POVERTY_EVOL_AMOUNTS_ASSIST_CHART =
    'EdfPovertyEvolAmountFileAssistedChart';
export const EDF_CUSTOMERS_POVERTY_EVOL_AMOUNT_POWER_REDUCTION_CHART =
    'EdfPovertyEvolPowerReducChart';
export const EDF_CUSTOMERS_POVERTY_EVOL_CUTS_UNPAID_CHART = 'EdfPovertyEvolCutsUnpaidChart';
